import { Skeleton, Box, Fab } from "@mui/material"
import { Dangerous, ElectricBolt, WavingHand } from "@mui/icons-material"

export const SwipeCardSkeleton = ({ showActions = true }) => {
    return (
        <Box sx={{ width: '100%', maxWidth: 520, mx: 'auto', position: 'relative', pb: 10 }}>
            <Box sx={{ borderRadius: 3, overflow: 'hidden', boxShadow: '0 4px 24px rgba(0,0,0,0.10)', background: '#fff', p: 2.5 }}>
                <Skeleton variant="circular" width={80} height={80} sx={{ mx: 'auto', mb: 2 }} />
                <Skeleton variant="text" width="55%" height={28} sx={{ mx: 'auto' }} />
                <Skeleton variant="text" width="40%" height={20} sx={{ mx: 'auto', mb: 2 }} />
                <Skeleton variant="rectangular" width="100%" height={220} sx={{ borderRadius: 2, mb: 1.5 }} />
                <Skeleton variant="text" width="90%" sx={{ mx: 'auto' }} />
                <Skeleton variant="text" width="70%" sx={{ mx: 'auto' }} />
                <Skeleton variant="text" width="80%" sx={{ mx: 'auto' }} />
            </Box>

            {showActions && (
                <Box sx={{
                    position: 'fixed',
                    bottom: { xs: 70, sm: 24 },
                    left: '50%',
                    transform: 'translateX(-50%)',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 2.5,
                    zIndex: 20,
                    background: 'rgba(255,255,255,0.92)',
                    backdropFilter: 'blur(12px)',
                    borderRadius: 50,
                    px: 3.5, py: 1.5,
                    boxShadow: '0 4px 32px rgba(0,0,0,0.14)',
                }}>
                    <Fab size="medium" disabled sx={{ width: 56, height: 56 }}>
                        <Dangerous />
                    </Fab>
                    <Fab size="medium" disabled sx={{ width: 68, height: 68 }}>
                        <WavingHand sx={{ fontSize: 32 }} />
                    </Fab>
                    <Fab size="medium" disabled sx={{ width: 56, height: 56 }}>
                        <ElectricBolt />
                    </Fab>
                </Box>
            )}
        </Box>
    )
}
